import React, { useState } from 'react';
import { useLocalization } from '../../utils/hooks/useLocalization'
import products from "../../data/product";
import artists from "../../data/artist";
import styles from './ProductsPage.module.css';

const ProductsPage = ({ arePreordersOpen }) => {
  const { t, currentLanguage } = useLocalization();
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const renderPreordersOpen = (
    <div className={styles.orderInfo}>
      <p className={styles.subtitle}>
        Preorders are <b>open</b> <br />delivery at <i>Furizon Polaris 2026</i>
      </p>
      <div className={styles.cta}>
        <button className={styles.ctaBtn}>
          Preorder Now
        </button>
      </div>
    </div>
  );

  const renderPreordersClosed = (
    <div className={styles.orderInfo}>
      <p className={styles.subtitle}>
        Preorders are <b>not open yet</b>
      </p>
      <p className={styles.subtitle}>
        Keep an eye on the updates on our socials!
      </p>
    </div>
  );

  return (
      <section id="products" className={styles.products}>
        <div className={styles.container}>
        {/* Section Header */}
          <div className={styles.header}>
            <h2 className={styles.title}>
              <span className={styles.titleMain}>OUR</span>
              <span className={styles.titleAccent}>COLLECTION</span>
            </h2>
          </div>
          <div className={styles.productsWrapper}>
            <p className={styles.intro}>
              {t("products_subtitle")}
            </p>
            <div className={styles.grid}>
              {products.items.map((product) => {
                const artist = artists.items.find((a) => a.id === product.artist_id);
                return (
                  <a
                    key={product.id}
                    className={styles.card}
                    onMouseEnter={() => setHoveredProduct(product.id)}
                    onMouseLeave={() => setHoveredProduct(null)}
                    href={`product/${product.id}`}
                  >
                    <div>
                      {/* Large Image Area */}
                      <div className={styles.imageContainer}>
                        <img 
                          src={require(`../../../images/${product.id_photos_preview}`)}
                          alt={product.name}
                          className={styles.image}
                        />

                        {/* Category Badge */}
                        <div className={styles.categoryBadge}>
                          {artist?.nickName}
                        </div>
                      </div>

                      {/* Compact Product Info */}
                      <div className={styles.info}>
                        <h3 className={styles.productName}>{product.name}</h3>
                        <h6 className={styles.description}>{product.briefDescription[currentLanguage]}</h6>
                      </div>
                    </div>
                    {/* <div className={styles.footer}>
                      <span className={styles.price}>{product.price}</span>
                    </div> */}
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </section>
  );
};

export default ProductsPage;